














import { Component, Vue } from 'vue-property-decorator';
import { CombinationService, PresetService } from '@/api';
import { Combination, createCombination, createPreset, Preset } from '@/types';
import UTabs from '@/ui-lib/tabs/Tabs.vue';
import UTab from '@/ui-lib/tabs/Tab.vue';

@Component<CombinationItemView>({
  components: {
    UTabs,
    UTab
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const combinationId = parseInt(to.params.id, 10);
      const combination = await CombinationService.item(combinationId);
      const preset = await PresetService.item(combination.presetId);

      next((vm) => {
        vm.combination = combination;
        vm.preset = preset;
      });
    } catch (e) {
      next(e);
    }
  },

  metaInfo() {
    return {
      titleTemplate: `${this.name} - %s`
    };
  }
})
export default class CombinationItemView extends Vue {
  private combination: Combination = createCombination();
  private preset: Preset = createPreset();

  private get name() {
    return `Комбинация: дин: ${this.combination.dynamics} | ак: ${this.combination.acoustics} (${this.preset.name})`;
  }
}
